import { fetch } from 'wix-fetch';

export async function getLoggedInUser() {
	let loggedIn;
	const url = `https://www.wix.com/_api/wix-html-login-webapp/user/getUserDetails`;
	let results = await fetch(url).then(
		async (response) => {
			if (response.status !== 200) {
				Promise.reject('Problem in fetching')
			}
			await response.text().then((data) => {
				const values = data
				values.indexOf('"success":true') === -1 ? loggedIn = false : loggedIn = true;
				Promise.resolve(loggedIn)
			});
		});
	return loggedIn;
}